import React from "react";
import { X } from "lucide-react";

const EndCVSelfCheckModal = ({ isOpen, onClose, onNextPart }) => {
    if (!isOpen) return null;

    // FIX CỨNG CHECKLIST GIỐNG ẢNH BẠN GỬI
    const checklist = [
        {
            group_title: "Essential Requirements (Gating)",
            items: [
                "I’ve clearly listed all the must-have qualifications.",
                "My key certifications appear in a prominent ‘Education’ or ‘Certification & Training’ section.",
                "Beyond essentials, I’ve listed additional credentials (optional).",
            ],
        },
        {
            group_title: "Task Alignment",
            items: [
                "For each core duty in the job ad, I have at least one bullet showing how I performed it.",
                "I’ve supported my points with evidence.",
            ],
        },
        {
            group_title: "Socio-cultural Context",
            items: [
                "My tone is formal and professional.",
                "I use headings and bullets; I’ve avoided long narrative paragraphs.",
            ],
        },
        {
            group_title: "Formatting & Presentation",
            items: [
                "All sections use the same font, size, and spacing.",
                "Bullets are aligned and consistently punctuated.",
                "There’s enough white space, no walls of text or overcrowded margins.",
            ],
        },
        {
            group_title: "Coherence & Cohesion",
            items: [
                "Each bullet logically builds on the heading above it.",
                "I have used brief linking words where needed.",
            ],
        },
        {
            group_title: "Impact & Metrics",
            items: [
                "Whenever possible, I’ve quantified my achievements: numbers, percentages, bands gained, etc.",
                "Vague statements are replaced with concrete facts.",
            ],
        },
        {
            group_title: "Lexical & Grammatical Resources",
            items: [
                "I ran a full proofread to catch typos and grammatical errors.",
                "I’ve paraphrased the core requirements in my own words, no copy paste.",
                "Vocabulary is varied and precise with no repeated filler words.",
            ],
        },
    ];

    // FIX CỨNG VIDEO (bạn thay link video thật vào sau)
    const videoUrl = "/AI_Video/test2_scenario1_writing_endcv.mp4";

    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-[9999]">
            <div className="bg-white rounded-xl w-[90%] max-w-5xl max-h-[90vh] overflow-y-auto shadow-xl relative">
                {/* Header */}
                <div className="flex justify-between items-center px-6 py-4 border-b">
                    <h2 className="text-xl font-semibold">CV Self-Check Checklist</h2>
                    <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
                        <X size={22} />
                    </button>
                </div>

                {/* Body */}
                <div className="p-6 flex gap-6">
                    {/* Left video */}
                    <div className="flex-shrink-0 w-[40%]">
                        <video src={videoUrl} className="w-full rounded-lg" controls />
                    </div>

                    {/* Right checklist */}
                    <div className="flex-1 overflow-y-auto pr-2">
                        <p className="text-sm text-gray-600 mb-4">
                            You have completed your CV. Before you submit, please watch this video and use the
                            checklist below to review your work and make any final improvements. Once you have
                            checked all the items, you can move to the next part.
                        </p>

                        <h3 className="text-lg font-semibold mb-4">CV Self-Check Checklist</h3>

                        <div className="space-y-5">
                            {checklist.map((group, idx) => (
                                <div key={idx} className="border rounded-lg p-4 bg-gray-50">
                                    <h4 className="font-semibold text-blue-700 mb-2 text-sm">
                                        {group.group_title}
                                    </h4>
                                    <ul className="space-y-2">
                                        {group.items.map((item, subIdx) => (
                                            <li key={subIdx} className="flex items-start gap-2 text-sm">
                                                <input type="checkbox" className="mt-1" />
                                                <span>{item}</span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                        </div>

                        {/* Next Part Button */}
                        <div className="mt-6 flex justify-end">
                            <button
                                onClick={onNextPart}
                                className="px-6 py-2 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700"
                            >
                                Next Part
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EndCVSelfCheckModal;
